// Module
var code = "<div class=\"input-group\"> <div class=\"input-group-addon\">$</div> <input type=\"text\" class=\"form-control\" ng-model=\"vm.value\" id=\"fieldresponse_{{vm.fieldResponse.id}}\" placeholder=\"{{ vm.requiredPlaceholderText | lowercase }}\"> </div> ";
// Exports
module.exports = code;